// Default Vinted-style clothing categories for Algeria
export const defaultCategories = [
  {
    title: "Femmes",
    items: [
      "Hauts & T-shirts",
      "Robes",
      "Combinaisons",
      "Manteaux & Vestes",
      "Pantalons & Jeans",
      "Jupes",
      "Pulls & Sweats",
      "Lingerie & Pyjamas",
      "Maillots de bain",
      "Maternité",
      "Chaussures femmes",
      "Sacs & Maroquinerie",
      "Bijoux & Montres",
      "Accessoires femmes",
    ],
  },
  {
    title: "Hommes",
    items: [
      "T-shirts & Tops",
      "Chemises & Polos",
      "Vestes & Manteaux",
      "Pantalons & Jeans",
      "Pulls & Sweats",
      "Shorts & Bermudas",
      "Costumes",
      "Chaussures hommes",
      "Sacs & Bagagerie",
      "Accessoires hommes",
    ],
  },
  {
    title: "Enfants",
    items: [
      "Bébé fille (0-3 ans)",
      "Bébé garçon (0-3 ans)",
      "Filles (3-14 ans)",
      "Garçons (3-14 ans)",
      "Chaussures enfants",
      "Accessoires enfants",
    ],
  },
  {
    title: "Sport & Fitness",
    items: [
      "Tenues de sport femmes",
      "Tenues de sport hommes",
      "Chaussures de sport",
      "Maillots & Shorts",
      "Vêtements de yoga",
      "Accessoires sport",
    ],
  },
  {
    title: "Mariage & Soirée",
    items: [
      "Robes de soirée",
      "Robes de mariée",
      "Costumes & Smokings",
      "Tenues kabyles & traditionnelles",
      "Accessoires mariage",
    ],
  },
  {
    title: "Maison & Articles de maison",
    items: [
      "Meubles",
      "Literie & Linge de maison",
      "Vaisselle & Cuisine",
      "Électroménager",
      "Décoration",
      "Jardinage & Plantes",
      "Bricolage & Outillage",
    ],
  },
  {
    title: "Divertissement",
    items: [
      "Films & Séries",
      "Musique & Instruments",
      "Jeux vidéo & Consoles",
      "Livres & BD",
      "Jouets & Jeux de société",
    ],
  },
  {
    title: "Loisirs & Collection",
    items: [
      "Art & Artisanat",
      "Philatélie & Numismatique",
      "Antiquités & Objets de collection",
      "Bijoux vintage",
      "Matériel photo & vidéo",
      "Collections diverses",
    ],
  },
];

// Always read fresh from localStorage (used in admin panel)
export function getCategories() {
  try {
    const stored = localStorage.getItem("9achna_categories");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch {
    // ignore
  }
  return defaultCategories;
}

// Save custom categories to localStorage
export function saveCategories(cats) {
  localStorage.setItem("9achna_categories", JSON.stringify(cats));
}

// Static export — computed at module load time (refreshes on page reload)
export const categories = getCategories();

// ── Clothing-only segmentation (pivot Vinted Algerie 2026) ────────────────
// Maison/Divertissement/Loisirs sont conservés dans defaultCategories pour
// ne pas casser les annonces existantes, mais on filtre ici pour la navigation
// et le SEO. Coté next-app : noindex,follow sur les pages non-clothing.
export const CLOTHING_TITLES = [
  "Femmes",
  "Hommes",
  "Enfants",
  "Sport & Fitness",
  "Mariage & Soirée",
];

export const NON_CLOTHING_TITLES = [
  "Maison & Articles de maison",
  "Divertissement",
  "Loisirs & Collection",
];

export const isClothingCategory = (title) => CLOTHING_TITLES.includes(title);

export const clothingCategories = defaultCategories.filter((c) =>
  CLOTHING_TITLES.includes(c.title)
);
